import { initApp } from 'core/redux/actions/initApp/initAppActions';
import type { ApplicationState } from 'core/redux/reducers/rootReducer';
import type { AppThunkDispatch } from 'core/redux/store/configureStore.types';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

interface ComponentProps {
  children: JSX.Element;
}

function Init({ children }: ComponentProps) {
  const dispatch = useDispatch<AppThunkDispatch>();
  const { jsfUrl, loading } = useSelector((state: ApplicationState) => state.configuration);

  useEffect(() => {
    if (!jsfUrl && !loading) {
      dispatch(initApp());
    }
  }, [jsfUrl, loading, dispatch]);

  if (jsfUrl) {
    return children;
  }

  return null;
}

export default Init;
